import { gql } from 'apollo-angular';

const ADD_PERMISSION = gql`
  mutation addPermission($userId: Long!, $permission: UserPermissionType!) {
    addPermission(
      addPermissionRequest: { userId: $userId, permission: $permission }
    ) {
      id
      permissions
    }
  }
`;

export default ADD_PERMISSION;
